import gsap from 'gsap'
import {headerClass, language, SimpleBar, isAllMobileDevices, menuClass, loginPopupClass, colors} from './bundle'

let instance
class Search{
    constructor(){
        //Singleton
        if(instance){
            return instance
        }
        instance = this
        // console.log(colors)
        this.searchPage = document.querySelector('.search-page')

        this.popupActions = document.querySelector('.popup-actions')
        this.allPopus = [...this.popupActions.querySelectorAll('.popup-actions__item')]
        this.popupActionsBackground = this.popupActions.querySelector('.popup-actions__bg')
        this.popupActionsOverlay = this.popupActions.querySelector('.overlay')

        this.iconaSearch = document.querySelector('.action-cerca')
        this.openPopupSearchBtns = [...document.querySelectorAll('.open-popup-search-btn')]
        this.form = document.querySelector('.search-page form')
        this.input = this.form.querySelector('input')

        this.closeSearchBtns = [...document.querySelectorAll('.close-search-form-btn')]
        this.cleanButton = this.form.querySelector('.clean-button')
        
        this.container = this.form.closest('.search-form')
        this.content = this.form.closest('.search-form').querySelector('.content')
        this.contentOffset = this.content.getBoundingClientRect().top
        // console.log(winsize.height, this.contentOffset)
        this.contentWrapper = this.content.querySelector('.content__wrapper .products')
        // console.log(this.contentWrapper)
        this.ctaTxt = 'Vedi'
        this.txtNoResults = 'La ricerca non ha prodotto alcun risultato'
        this.txtAddToCart = 'Aggiungi al carrello'
        this.txtDiscover = 'Discover'        
        if (language !== 'it') {
            this.ctaTxt = 'View'
            this.txtNoResults = 'Your search produced no results.'
            this.txtAddToCart = 'Add to cart'
        }


        /**
         * MOBILE
         */
        this.containerMobileMenus = document.querySelector('.container-mobile-menus')

        //Bool
        this.isAnimating = false


        this.setDomSizes()
        this.initEvents()

    }

    initEvents(){
        this.form.addEventListener('submit', e => {
            e.preventDefault()
        })

        this.openPopupSearchBtns.forEach(openBtn => {
            openBtn.addEventListener('click', () => {
                if (this.isAnimating) return
                this.isAnimating = true
                if (this.iconaSearch.classList.contains('opened')) {
                    this.closeSearch()
                    //Disattivato dopo che ho spostato l'header feed vino dentro all'header  
                    // if(document.querySelector('.page-single-product-vino') !== null){
                    //     headerClass.apriHeaderFeedVino()
                    // }
                }
                else {
                    if(document.querySelector('.popup-actions__item.popup-active') !== null){
                        const dataOtherPopup = document.querySelector('.popup-active').getAttribute('data-popup-element')
                        // console.log('chiudere prima il ', dataOtherPopup)
    
                        if(dataOtherPopup === 'menu'){
                            menuClass.closeMenu('search').then( () => {
                                this.openSearch()
                            })
                        }
                        else if(dataOtherPopup === 'login'){
                            // loginPopupClass = new LoginPopup()
                            loginPopupClass.closeLoginPopup('search').then( () => {
                                this.openSearch()
                            })
    
                        }
                    }
                    //Menu mobile aperto
                    else if(this.containerMobileMenus.classList.contains('menu-mobile-active')){
                        if(this.containerMobileMenus.querySelector('.submenu-mobile.opened') !== null){
                            menuClass.closeSubmenuMobile()
                        }
                        const fromAnotherEl = true
                        menuClass.closeMenuMobile(fromAnotherEl).then( () => {
                            this.openSearch()
                        })
                    }
                    else {
                        this.openSearch()
                    }
                }
            })

        })

        this.closeSearchBtns.forEach(closeBtn => {
            closeBtn.addEventListener('click', () => {
                this.closeSearch()

                //Disattivato dopo che ho spostato l'header feed vino dentro all'header  
                // if(document.querySelector('.page-single-product-vino') !== null){
                //     headerClass.apriHeaderFeedVino()
                // }
            })
        })

        this.cleanButton.addEventListener('click', () => {
            this.cleanSearch()
        })
        this.input.addEventListener('keyup', () => {
            this.string = this.input.value
            if (this.string.length > 1) {
                clearTimeout(this.timeout)
                this.timeout = setTimeout(() => {
                    this.searchAjax()
                    gsap.to(this.cleanButton, {
                        duration: 0.6,
                        autoAlpha: 1
                    })
                }, 200)
            }
            else {
                gsap.to(this.cleanButton, {
                    duration: 0.6,
                    autoAlpha: 1
                })
            }

            // return this.string
            // console.log(this.string)
        })
    }

    cleanSearch() {
        this.input.value = '';
        this.contentWrapper.innerHTML = '';
        this.input.focus();
        gsap.to(this.cleanButton, {
            duration: 0.3,
            autoAlpha: 0
        })
    }    

    searchAjax() {
        let formData = new FormData(this.form)
        let request = new XMLHttpRequest()
        let url = document.getElementById('uri').value + '/AJAX/search.php'
        request.open('POST', url, true)
        request.onreadystatechange = () => {
            if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
                let resultObj = JSON.parse(request.response);
                //Nessun risultato
                if (resultObj.risposta === 'none') {
                    // console.log('fill response wrapper')
                    this.contentWrapper.innerHTML = '<p class="verde no-result">' + this.txtNoResults + '</p>';
                }
                //Qualche risultato
                else {
                    // console.log(resultObj)
                    let item = '';
                    // let contatore = 0;
                    let position = '';
                    resultObj.forEach(obj => {
                        // contatore++;
                        // if ((contatore % 2) == 0) {
                        //     position = 'right'
                        // }
                        // else {
                        //     position = 'left';
                        // }
                //         if ((contatore % 2) !== 0) {
                //             item += '<div class="row-float clearfix">';
                //         }
                        // item += '<div class="link ' + obj.type + ' ' + position + ' cta-trigger reverse">';
                        item += '<div class="product">';
                            item += '<div class="product__wrapper">';
                                item += '<a href="' + obj.url + '">';
                                    item += '<div class="product__border vertical"></div>';
                                    item += '<div class="product__border horizontal"></div>';
                                    item += '<div class="product__image">';
                                            item += '<img src="' + obj.image + '">';
                                    item += '</div>';
                                    item += '<div class="product__info">';
                                        item += '<div class="product__title">';
                                            item += '<div class="title__wrapper">';
                                                item += '<div class="relative">';
                                                    item += '<h3 class="uppercase medium-text">' + obj.title + '</h3>';
                                                item += '</div>';
                                                item += '<div class="absolute">';
                                                    item += '<h3 class="uppercase medium-text">' + obj.title + '</h3>';
                                                item += '</div>';
                                            item += '</div>';
                                        item += '</div>';
                                    item += '</div>';
                    //                     // item += '<div class="link__category">';
                    //                     //     item += '<span class="uppercase">' + obj.categoryName + '</span>';
                    //                     // item += '</div>';
                    //                     item += '<div class="product__cta">';
                    //                         item += '<div class="cta-stroke-white">';
                    //                             item += '<div class="cta__bg"></div>';
                    //                             item += '<div class="cta__border"></div>';
                    //                             item += '<div class="cta__wrapper">';
                    //                                 item += '<div class="cta__txt">';
                    //                                     item += '<span class="uppercase">' + this.txtDiscover + '</span>';
                    //                                 item += '</div>';
                    //                             item += '</div>';
                    //                         item += '</div>';
                    //                     item += '</div>';
                    //                     item += '<div class="link__border">';
                    //                         item += '<span></span>';
                    //                     item += '</div>';
                                item += '</a>';
                            item += '</div>';
                        item += '</div>';

                //         if ((contatore % 2) == 0 || (obj.totale % 2 !== 0 && contatore == obj.totale)) {
                //             item += '</div>';
                //         }

                    })

                    this.contentWrapper.innerHTML = item;
                    // setTimeout(() => {
                        new SimpleBar(this.content, { autoHide: false });
                    // },5000)

                }
            }
        }
        request.send(formData)

    }
    setZindex(){
        gsap.set(this.searchPage,{
            'z-index': 7
        })
        this.allPopus.forEach( popup => {
            if(!popup.isSameNode(this.searchPage)){
                gsap.set(popup,{
                    'z-index': 3
                })
            }
        })

    }

    setDomSizes() {
        gsap.to(this.content, {
            duration: 0,
            // Se si imposta il main container display: none
            // height: winsize.height - this.contentOffset - 80
            //Se si sposta il main container di y:-100%
            height: - this.contentOffset - 80
        })
    }
    openSearch(){
        if(isAllMobileDevices){
            document.body.style.overflow = 'hidden'
        }
        this.iconaSearch.classList.add('opened')
        this.searchPage.classList.add('popup-active')
        //update header elements color
        headerClass.toDefaultColor()
        this.setZindex()
        gsap.set(this.popupActions,{
            y: '0%'
        })
        this.input.focus()
        setTimeout(() => {
            this.input.focus()
        }, 600)

        //Disattivato dopo che ho spostato l'header feed vino dentro all'header  
        // headerClass.chiudiHeaderFeedVino()

        gsap.to(this.popupActionsBackground,{
            duration: 0.4,
            opacity: 1
        })
        gsap.to(this.popupActionsOverlay,{
            duration: 0.4,
            opacity: 1
        })

        gsap.to(this.searchPage, {
            duration: 0.6,
            autoAlpha: 1,
            delay:0.2,
            onComplete: () => {
                this.isAnimating = false

            }
        })

        // this.contentOffset = this.content.getBoundingClientRect().top
    }

    closeSearch(fromAnotherPopup = false) {
        return new Promise( resolve => {
            if(isAllMobileDevices){
                document.body.style.overflow = 'scroll'
            }
            this.iconaSearch.classList.remove('opened')
            this.searchPage.classList.remove('popup-active')

            gsap.to(this.searchPage, {
                duration: 0.4,
                autoAlpha: 0,
                delay:0.2,
                onComplete: () => {
                    this.animating = false

                }
            })
            if(!fromAnotherPopup){
                gsap.to(this.popupActionsBackground,{
                    duration: 0.3,
                    opacity: 0,
                    delay: 0.3,
                    onComplete: () => {
                        gsap.set(this.popupActions,{
                            y: '-100%'
                        })
                        gsap.set(this.popupActionsOverlay,{
                            opacity: 0
                        })
                        this.isAnimating = false
                        resolve()
                    }
                })
                //update header elements color
                const bgPageColor = getComputedStyle(document.querySelector('body')).backgroundColor
                if(bgPageColor === colors.panna){
                    headerClass.toAlternativeColor()
                }
                else{
                    headerClass.toDefaultColor()
                } 

            }
            else{
                // if(fromAnotherPopup === 'menu'){
                    gsap.to(this.popupActionsOverlay,{
                        duration: 0.3,
                        opacity: 0,
                        delay: 0.2,
                        onComplete: () => {
                            this.isAnimating = false
                            resolve()
                        }
                    })
                // }
                // else{
                //     this.isAnimating = false
                //     resolve()
                // }

            }
        })
    }

}

export {Search}
